<template>
    <div class="wrapper-bg">
        <div class="main-layout coffee">
            <HeaderOther
                setTitle="Beverage"
                :setHref="'subscriptionform'"
                :showLogo="false"
            />
            <div class="beverage-main">
                <div class="beverage-header">
                    Beverage
                </div>
                <div class="list-container">
                    <BeverageList
                        :beverage="data"
                        @setDefaultCup="setDefaultCup"
                    />
                </div>
            </div>
            <Footer
                text="เลือก"
                action="nextWithParams"
                path="subscriptionform"
                :param="defaultItem"
            ></Footer>
        </div>
    </div>
</template>

<script>
//components
import HeaderOther from "@/components/Header/HeaderOther.vue";
import Footer from "@/module/Subscription/components/Footer.vue";
import BeverageList from "@/module/Subscription/components/BeverageList.vue";
//vuex
import { mapActions } from "vuex";

export default {
    name: "AllBeverage",
    components: {
        HeaderOther,
        Footer,
        BeverageList
    },
    props: {
        data: Array,
        beverage: Object
    },
    data() {
        return {
            defaultCup: "",
            defaultItem: {}
        };
    },
    created() {
        this.init();
    },
    methods: {
        ...mapActions(["setUserSubscription"]),
        init() {
            this.setUserSubscription({
                beverage: this.beverage
            });
        },
        setDefaultCup(cup) {
            this.defaultCup = cup.Name;
            this.defaultItem = this.data.filter(item => {
                return item.Name === this.defaultCup;
            })[0];
        }
    }
};
</script>

<style lang="scss" scoped>
.wrapper-bg {
    padding: 0;
    .beverage-header {
        padding: 10px 20px;
    }
    .list-container {
        padding: 0 32px;
    }
}
</style>
